export default "__VITE_ASSET__DkyJQmk9__"